// 22.01.19
// app auth
export const AUTH_TOKEN: string = "CBFA1D88-6D10-4284-8BF3-045077A521D7";
export const APP_NAME: string = "CICA";

// url
export const INTRO_PATH: string = "/";
export const DETAIL_PATH: string = "/detail";
export const INCIDENT_DETAIL_PATH: string = "/incident-detail";
export const HOME_PATH: string = "/home-ui";
//export const UI_HOME: string = "/ui-home";
export const ERROR_PATH: string = "/ui-error";
export const ACCESS_REQUEST_PATH: string = "/access-request";
export const PRINT_PATH: string = "/print";
export const SP_FORM_PATH: string = "/form-sp";
export const USERS_PATH: string = "/users";
export const Dashboard_PATH: string = "/dashboard";
export const SIGN_OUT_PATH: string = "/api/accounts/SignOut";
export const LOGIN_PATH: string = "/Home/Index1";

// api -- common
//export const BASE_PATH: string = "https://uni-cph-cica-apiservices.azurewebsites.net/api";
export const BASE_PATH: string = (window as any).SiteSettings.API_BASE_PATH; //'http://localhost:52194/api';

// api -- Cases
export const GET_CASE_ALL: string = BASE_PATH + "/Cases/GetCasesById/-1";
export const GET_CASE: string = BASE_PATH + "/Cases/GetCasesById/";
export const GET_CASES_BY_USER: string = BASE_PATH + "/Cases/GetCasesByUser/";
export const UPDATE_CASE: string = BASE_PATH + "/Cases/UpdateCases/";
export const SAVE_CASE: string = BASE_PATH + "/Cases/SaveCases/";

// api -- Pos
export const GET_POS_ALL: string = BASE_PATH + "/Pos/GetPosById/0";
export const GET_POS: string = BASE_PATH + "/Pos/GetPosById/";
export const UPDATE_POS: string = BASE_PATH + "/Pos/UpdatePos/";
export const SAVE_POS: string = BASE_PATH + "/Pos/SavePos/";

// api -- Shipments
export const GET_SHIPMENTS_ALL: string =
    BASE_PATH + "/Shipments/GetShipmentsById/0";
export const GET_SHIPMENTS: string = BASE_PATH + "/Shipments/GetShipmentsById/";
export const UPDATE_SHIPMENTS: string =
    BASE_PATH + "/Shipments/UpdateShipments/";
export const SAVE_SHIPMENTS: string = BASE_PATH + "/Shipments/SaveShipments/";

// api -- Qmus
export const GET_QMUS_ALL: string = BASE_PATH + "/Qmus/GetQmusById/0";
export const GET_QMUS: string = BASE_PATH + "/Qmus/GetQmusById/";
export const UPDATE_QMUS: string = BASE_PATH + "/Qmus/UpdateQmus/";
export const SAVE_QMUS: string = BASE_PATH + "/Qmus/SaveQmus/";

// api - Countries - all. By Id i.e. 1
export const GET_COUNTRY_ALL: string =
    BASE_PATH + "/Countries/GetCountriesById/-1";
export const GET_COUNTRY: string = BASE_PATH + "/Countries/GetCountriesById/";

// api - Grant Types - all. By Id i.e 1
export const GET_GRANTTYPES_ALL: string =
    BASE_PATH + "/MasterGrantTypes/GetMasterGrantTypesById/0";
export const GET_GRANTTYPES: string =
    BASE_PATH + "/MasterGrantTypes/GetMasterGrantTypesById/";

// api - Issue Types - all. By Id i.e 1
export const GET_ISSUETYPES_ALL: string =
    BASE_PATH + "/MasterIssueTypes/GetMasterIssueTypesById/0";
export const GET_ISSUETYPES: string =
    BASE_PATH + "/MasterIssueTypes/GetMasterIssueTypesById/";

// api - Claim Status - all. By Id i.e 1
export const GET_CLAIMSTATUS_ALL: string =
    BASE_PATH + "/MasterClaimStatus/GetMasterClaimStatusById/0";
export const GET_CLAIMSTATUS: string =
    BASE_PATH + "/MasterClaimStatus/GetMasterClaimStatusById/";

// api - Claim Types - all. By Id i.e 1
export const GET_CLAIMTYPES_ALL: string =
    BASE_PATH + "/MasterClaimTypes/GetMasterClaimTypesById/0";
export const GET_CLAIMTYPES: string =
    BASE_PATH + "/MasterClaimTypes/GetMasterClaimTypesById/";

// api - Users & Roles - all. By email or Id
export const GET_USERDETAILS_ALL: string =
    BASE_PATH + "/UserDetails/GetUserDetailsByUserNameOrId/-1";
export const GET_USERDETAILS: string =
    BASE_PATH + "/UserDetails/GetUserDetailsByUserNameOrId/";
export const GET_LOGGED_USERDETAILS: string =
    BASE_PATH + "/UserDetails/GetLoggedUserDetails";

// Home
export const GET_SP_USER_DATA_VIA_GRAPH: string = `${BASE_PATH}/UserDetails/SearchUser?lookup=`;

// api - Attachments
export const SAVE_ATTACHMENT_DATA: string = `${BASE_PATH}/Cases/SaveAttachmentDetails`;
export const DOWNLOAD_ATTACHMENT: string = `${BASE_PATH}/Cases/GetAttachmentDetails`;
export const DELETE_ATTACHMENT: string = `${BASE_PATH}/Cases/DeleteAttachmentDetails`;

// api - Case Lock/Unlock
export const CASE_LOCK_UNLOCK: string = `${BASE_PATH}/Cases/CheckInCheckOutCase`;
export const CASE_LOCK_FOR_EDIT: string = `${BASE_PATH}/Cases/CasesSetLockForEdit`;

// api - Solution Owner / Solution Team
export const SOLUTION_OWNER_TEAM: string = `${BASE_PATH}/UserDetails/GetSolutionUserDetails`;
export const REQUEST_FOR_CLOSE: string = `${BASE_PATH}/Cases/SendEmailNotificationOnRequestForClosure`;
export const SAVE_SP_USER: string = `${BASE_PATH}/UserDetails/SaveUserDetails`;

// api - Export
export const EXPORT_CLAIM: string = `${BASE_PATH}/Cases/ExportCases/claim`;
export const EXPORT_COMPLAINT: string = `${BASE_PATH}/Cases/ExportCases/complaint`;
export const EXPORT_INCIDENT_REPORT: string = `${BASE_PATH}/Cases/ExportCases/incident`;

// api -- types

export interface ICase {
    id?: number; // Auto increment.
    uniqueId?: string; // PK
    caseNo: string;
    caseType: CaseType;
    complaintStatus?: boolean;
    claimStatus?: ClaimStatus;
    claimType: ClaimType;
    insurancePolicyYear: string;
    legal?: boolean;
    legalComments: string;
    submittingOnBehalfOf: string;
    contactPerson: string;
    phone: string;
    email: string;
    countriesAffected: string;
    descriptionOfTheIssue: string;
    dateIssueNoticed: string; // Date
    expectedLossValue: string;
    expectedLossCurrency?: string;
    issueType: IssueType;
    inCaseOfShipment: string;
    comments: string;
    internalComments: string;
    evidenceAttachments?: boolean;
    shipmentNo: string;
    poNo: string;
    deliveryNo: string;
    created: string; // Date
    createdBy: string;
    modified: string; // Date
    modifiedBy: string;
    shipments: IShipment[];
    qmus: IQMU[];
    pos: IPo[];
    checkOutBy: string;
    category: string;
}

export interface IPo {
    id: number; // Auto increment. PK
    poNo?: string;
    poItemNo: string;
    materialShortText: string;
    materialGroup: string;
    material: string;
    assetNumbers: string;
    batchNo: string;
    packSize: string;
    serialNo: string;
    expiryDate: string;
    vendorName: string;
    vendorNo: string;
    orderType: string;
    freightForwarderName: string;
    freightForwarderNo: string;
    soldToParty: string;
    caseUniqueId: string; // FK
    created: string; // Date
    createdBy: string;
    modified: string; // Date
    modifiedBy: string;
    deleted?: boolean;
}

export interface IQMU {
    id: number; // Auto increment. PK
    centreToHandleComplaint: string;
    solutionOwner: any;
    caSolutionOwner: any;
    solutionTeam: any;
    validatedDate: string;
    validatedAsComplaint: number; // 3 values
    caseNo: string;
    recurrent?: boolean;
    caseComments: string;
    OER?: boolean;
    correctionIdentified: string; // Date
    correction: string;
    caseDateCI: string; // Date
    caseCommentsCI: string;
    correctionCompleted?: string; // Date
    rootCauseAnalysis: string;
    caseDateCC: string; // Date
    caseCommentsCC: string;
    correctiveActionIdentified: string; // Date
    correctiveAction: string;
    correctiveActionCompleted?: string; // Date
    requestForClosureOfComplaint?: boolean;
    attachments?: boolean;
    OERNumber: string;
    financialLossToSD: string;
    OERAttachments?: boolean;
    beingDrafted: string; // Date
    sentDOForPreapproval: string; // Date
    preapprovedByDO: string; // Date
    circulatedForComments: string; // Date
    circulatedForSignatures: string; // Date
    signed: string; // Date
    caseUniqueId: string; // FK
    created: string; // Date
    createdBy: string;
    modified: string; // Date
    modifiedBy: string;
    sentDoforPreapproval: string;
    preapprovedByDo: string;
}

export interface IShipment {
    id: number; // Auto increment. PK
    description: string;
    tampering?: boolean;
    sealIntact?: boolean;
    packingIntact?: boolean;
    containerNo: string;
    sealNo: string;
    dateReceivedInCountry: string; // Date
    quantity: string;
    customsClearanceDate: string; // Date
    forwarderReference: string;
    warehouseName: string;
    storageLocation: string;
    plantNo: string;
    address: string;
    salesOrderNo: string;
    freightForwarderName: string;
    actualFreightValue: string;
    EstimatedFreightValue: string;
    shipmentValue: string;
    BLDate: string; // Date
    BLWayBillAWB: string;
    vesselIDFlightNo: string;
    meansOfTransport: string;
    transportDepartureCountry: string;
    portAirportOfDeparture: string;
    transportDestinationCountry: string;
    portAirportOfDestination: string;
    originIncoterm: string;
    destinationIncoterm: string;
    transportStart: string; // Date
    transportEnd: string; // Date
    shipmentTotalQuantity: string;
    insurancePostingReference: string;
    reportedOn: string; // Date
    totalNumberOfPackages: string;
    actualInsuredValues: string;
    actualInsuredValuesCurrency?: string;
    estimatedInsuredValues: string;
    premium: string;
    premiumCurrency?: string;
    quantityLostPerMaterialLevel: string;
    totalClaimsValuesSupplies: string;
    totalClaimsValuesSuppliesCurrency?: string;
    claimsValueFreight: string;
    claimsValueFreightCurrency?: string;
    uplift: string;
    upliftCurrency?: string;
    deductibleUnderThePolicy: string;
    deductibleUnderThePolicyCurrency?: string;
    totalValueOfLoss: string;
    totalValueOfLossCurrency?: string;
    PSB?: boolean;
    psbcomments: string;
    recoveryValue: string;
    attachments?: boolean;
    WBSNo: string;
    grantNo: string;
    grantExpiry: string; // Date
    grantType: number;
    nameOfThirdParty: string;
    amountOfRecoveryObtained: string;
    recovery?: boolean;
    surveyorDetailsCompanyName: string;
    contactPerson: string;
    SDAddress: string;
    email: string;
    telephone: string;
    brokerReference: string;
    claimDesignation: string;
    presentedForSettlement: string; // Date
    claimClosed: string; // Date
    settlementAgreed: string; // Date
    SDSettlementDocumentNo: string;
    SDSettlementDocumentAttachments?: boolean;
    caseUniqueId: string; // FK
    created: string; // Date
    createdBy: string;
    modified: string; // Date
    modifiedBy: string;
    bldate: string;
}

export interface IUserDetail {
    userName: string; // I.e. "qmu2@gmail.com",
    roleId: number; // 1, 2, 3, 4, 5 or 6
    id: string; // I.e. "2504C784-D360-448D-B946-A535F730879F"
    role: {
        id: number;
        name: string;
    };
}
export interface IAADUserDetails {
    name: string;
    firstName: string;
    lastName: string;
    emails: string;
    city: string;
    country: string;
}
export interface IIssueType {
    id: IssueType;
    name: string;
    caseFormType: CaseFormType;
}

export interface IClaimType {
    id: number;
    name: string;
    [key: string]: any;
}

export interface IClaimStatus {
    id: ClaimStatus;
    name: string;
    [key: string]: any;
}

export interface IGrantType {
    id: number;
    name: string;
    [key: string]: any;
}

export interface ICountry {
    id: number;
    countryName: string;
    unicefregion: string;
    whoregion: string;
    isoalpha3code: string;
    isActive: boolean;
}

export enum CaseType {
    Complaint = 1,
    Claim = 2,
    ComplaintClaim = 3,
}

export enum UserRoles {
    Admin = 1,
    QMU = 2,
    INS = 3,
    FMC = 4,
    UNICEF = 5, // Unicef/Requestor both roles are same
    Partner = 6,
    Solution_Owner = 7,
    Solution_Team = 8,
}

export enum AccessTypeEnum {
    STANDARD_UNICEF_COMPLAINT_CLAIM = 1,
    UNICEF_GAVI_INCIDENT_REPORT = 2,
    BOTH = 3,
}

// this maps from caseType to the title because we can't fetch case types from the API
export const caseTypeNameMap: { [type in CaseType]: string } = {
    [CaseType.Complaint]: "Complaint",
    [CaseType.Claim]: "Claim",
    [CaseType.ComplaintClaim]: "Complaint & Claim",
};

// Utility functions for conditional fields
export function isClaim(caseType: CaseType) {
    return caseType === CaseType.Claim || caseType === CaseType.ComplaintClaim;
}

export function isComplaint(caseType: CaseType) {
    return (
        caseType === CaseType.Complaint || caseType === CaseType.ComplaintClaim
    );
}

export const isOneOf = (...args: any) => (val: any) => {
    return args.indexOf(val) > -1;
};

export enum ClaimStatus {
    Open = 1,
    PendingInfo = 2,
    SubmittedToBroker = 3,
    Closed = 4,
    Withdrawn = 5,
}

export enum ClaimType {
    Transit = 1,
    Inventory = 2,
    PoliticalViolence = 3,
}

export enum IssueType {
    Shipment = 1,
    Invoicing = 2,
    ProductQuality = 3,
    Packaging = 4,
    Process = 5,
    Inventory = 6,
    Other = 7,
    Pharmacovigilance = 8,
    GoodsMaterialReceipt = 9,
    GoodsProduction = 10,
    GoodsDeliveryPacking = 11,
    OperationalIssues = 12,
}
export const issueTypeLabels: Record<number, string> = {
    [IssueType.Shipment]: "Shipment",
    [IssueType.Invoicing]: "Invoicing",
    [IssueType.ProductQuality]: "Product quality",
    [IssueType.Packaging]: "Packaging",
    [IssueType.Process]: "Process",
    [IssueType.Inventory]: "Inventory",
    [IssueType.Other]: "Other",
    [IssueType.Pharmacovigilance]: "Pharmacovigilance",
    [IssueType.GoodsMaterialReceipt]: "Goods Material Receipt",
    [IssueType.GoodsProduction]: "Goods Production",
    [IssueType.GoodsDeliveryPacking]: "Goods Delivery Packing",
    [IssueType.OperationalIssues]: "Operational Issues",
}

export enum CaseFormType {
    Standard = "Standard",
    Incident = "Incident",
    WarehouseNonConformity = "WarehouseNonConformity",
}
export const caseFormTypeLabels: Record<string, string> = {
    [CaseFormType.Standard]: "Standard",
    [CaseFormType.Incident]: "Incident",
    [CaseFormType.WarehouseNonConformity]: "Warehouse Nonconformity",
}

export const rolePaths: { [path: string]: number[] } = {
    "/": [0, 1, 2, 3, 4, 5, 6],
    "/detail": [0, 1, 2, 3, 4, 5, 6],
    "/home": [0, 1, 2, 3, 4, 5], // The view can not be seen if the user is a partner.
};

export function isAllowed(path: string, roleId?: number) {
    if (roleId === undefined) {
        return true;
    }
    return rolePaths[path].find((n) => n === roleId) !== undefined;
}

export class Guid {
    public static newGuid() {
        return "xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx".replace(/[xy]/g, (c) => {
            // tslint:disable-next-line:no-bitwise
            const r = (Math.random() * 16) | 0;
            // tslint:disable-next-line:no-bitwise
            const v = c === "x" ? r : (r & 0x3) | 0x8;
            return v.toString(16);
        });
    }
}

// Site settings Data

export const solutionCentreList: any = (window as any).solutionCentreList;

// test users

export const testUsers: Array<Pick<
    IUserDetail,
    "userName" | "roleId" | "id"
>> = [
        {
            userName: "ins3@gmail.com",
            roleId: 3,
            id: "00AFD967-4BF7-436C-88BA-86EA2BA1F5CE",
        },
        {
            userName: "qmu2@gmail.com",
            roleId: 2,
            id: "2504C784-D360-448D-B946-A535F730879F",
        },
        {
            userName: "ins2@gmail.com",
            roleId: 3,
            id: "3E23DCF8-774F-44FC-B290-86CBD2FDDBF8",
        },
        {
            userName: "ins1@gmail.com",
            roleId: 3,
            id: "57C30C01-3B4F-41CD-B386-FFB875CCE5C9",
        },
        {
            userName: "admin@gmail.com",
            roleId: 1,
            id: "6B644AF7-C16A-46B3-B1C4-AEE730EFE398",
        },
        {
            userName: "uni1@gmail.com",
            roleId: 5,
            id: "D55DC1E4-FF19-4573-9C6E-74AD29FE710B",
        },
        {
            userName: "fmc1@gmail.com",
            roleId: 4,
            id: "D55DC1E4-FF19-4573-9C6E-74AD29FE710C",
        },
        {
            userName: "partner1@gmail.com",
            roleId: 6,
            id: "D55DC1E4-FF19-4573-9C6E-74AD29FE710E",
        },
    ];

export const validatePOs = (
    pos: IPo[],
    allValues: any,
    props: any,
    name: any
): number[] | undefined => {
    if (pos) {
        const invalid = Array.from(pos.entries())
            .filter(([idx, po]) => !po.poNo)
            .map(([idx, val]) => idx);
        if (invalid.length > 0) {
            return invalid;
        } else {
            return undefined;
        }
    }
    return undefined;
};
